/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DashboardUser
 */
export interface DashboardUser {
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  userId: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof DashboardUser
   */
  lastLoginAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  phoneExtension: string;
  /**
   *
   * @type {boolean}
   * @memberof DashboardUser
   */
  accountingNotificationsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DashboardUser
   */
  allShipmentNotificationsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DashboardUser
   */
  deliveryNotificationsOnlyEnabled: boolean;
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  branchName?: string | null;
  /**
   *
   * @type {string}
   * @memberof DashboardUser
   */
  branchId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DashboardUser
   */
  allowedToSwitchToLinkedCompanies: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DashboardUser
   */
  belongsToThisCompany: boolean;
}

/**
 * Check if a given object implements the DashboardUser interface.
 */
export function instanceOfDashboardUser(value: object): value is DashboardUser {
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("userId" in value) || value["userId"] === undefined) return false;
  if (!("lastLoginAt" in value) || value["lastLoginAt"] === undefined)
    return false;
  if (!("phone" in value) || value["phone"] === undefined) return false;
  if (!("phoneExtension" in value) || value["phoneExtension"] === undefined)
    return false;
  if (
    !("accountingNotificationsEnabled" in value) ||
    value["accountingNotificationsEnabled"] === undefined
  )
    return false;
  if (
    !("allShipmentNotificationsEnabled" in value) ||
    value["allShipmentNotificationsEnabled"] === undefined
  )
    return false;
  if (
    !("deliveryNotificationsOnlyEnabled" in value) ||
    value["deliveryNotificationsOnlyEnabled"] === undefined
  )
    return false;
  if (
    !("allowedToSwitchToLinkedCompanies" in value) ||
    value["allowedToSwitchToLinkedCompanies"] === undefined
  )
    return false;
  if (
    !("belongsToThisCompany" in value) ||
    value["belongsToThisCompany"] === undefined
  )
    return false;
  return true;
}

export function DashboardUserFromJSON(json: any): DashboardUser {
  return DashboardUserFromJSONTyped(json, false);
}

export function DashboardUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardUser {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    name: json["name"],
    userId: json["userId"],
    lastLoginAt: json["lastLoginAt"],
    phone: json["phone"],
    phoneExtension: json["phoneExtension"],
    accountingNotificationsEnabled: json["accountingNotificationsEnabled"],
    allShipmentNotificationsEnabled: json["allShipmentNotificationsEnabled"],
    deliveryNotificationsOnlyEnabled: json["deliveryNotificationsOnlyEnabled"],
    branchName: json["branchName"] == null ? undefined : json["branchName"],
    branchId: json["branchId"] == null ? undefined : json["branchId"],
    allowedToSwitchToLinkedCompanies: json["allowedToSwitchToLinkedCompanies"],
    belongsToThisCompany: json["belongsToThisCompany"],
  };
}

export function DashboardUserToJSON(json: any): DashboardUser {
  return DashboardUserToJSONTyped(json, false);
}

export function DashboardUserToJSONTyped(
  value?: DashboardUser | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    name: value["name"],
    userId: value["userId"],
    lastLoginAt: value["lastLoginAt"],
    phone: value["phone"],
    phoneExtension: value["phoneExtension"],
    accountingNotificationsEnabled: value["accountingNotificationsEnabled"],
    allShipmentNotificationsEnabled: value["allShipmentNotificationsEnabled"],
    deliveryNotificationsOnlyEnabled: value["deliveryNotificationsOnlyEnabled"],
    branchName: value["branchName"],
    branchId: value["branchId"],
    allowedToSwitchToLinkedCompanies: value["allowedToSwitchToLinkedCompanies"],
    belongsToThisCompany: value["belongsToThisCompany"],
  };
}
